import { COLORS } from 'appconstants';
import { setUser } from 'store/slices/common-slice';
import { AppDispatch } from 'store/store';
import { toast } from 'sonner';

interface RequestHandlerParams {
  apiService: (param_data?: any) => Promise<any>;
  setData?: (data: any) => { payload: any; type: string };
  setLoading?: (loading: boolean) => { payload: boolean; type: string };
  isSuccessMessage?: boolean;
  param_data?: any;
  onDone?: (data: any) => void;
  isErrorMessage?: boolean;
  onError?: (error: any) => void;
}

export const searchArray = (data, keyword) => {
  const result = [];
  data?.forEach(item => {
    let matched = false;
    Object.keys(item).forEach(key => {
      if (
        item &&
        typeof item[key] === 'string' &&
        (item[key]?.toLowerCase().includes(keyword.toLowerCase()) ||
          item[key]?.toLowerCase().match(keyword.toLowerCase()))
      ) {
        return (matched = true);
      } else if (item && typeof item[key] === 'object') {
        if (item[key]) {
          Object.keys(item[key]).forEach(val => {
            if (
              item[key][val] &&
              typeof item[key][val] === 'string' &&
              (item[key][val]?.toLowerCase().includes(keyword.toLowerCase()) ||
                item[key][val]?.toLowerCase().match(keyword.toLowerCase()))
            ) {
              return (matched = true);
            }
          });
        }
      } else if (
        item &&
        typeof item[key] === 'number' &&
        (item[key]?.toString()?.toLowerCase().match(keyword.toLowerCase()) ||
          item[key]?.toString()?.toLowerCase().includes(keyword.toLowerCase()))
      ) {
        return (matched = true);
      }
    });
    if (matched) {
      result.push(item);
    }
  });
  return result;
};

export function requestHandler({
  apiService,
  setData,
  setLoading,
  isSuccessMessage = false,
  param_data,
  onDone,
  isErrorMessage = true,
  onError,
}: RequestHandlerParams) {
  return async (dispatch: AppDispatch) => {
    try {
      setLoading && dispatch(setLoading(true));
      const response = await apiService(param_data);
      if (response?.status === 200 || response?.data?.status === true) {
        setData && dispatch(setData(response?.data?.data ?? null));
        isSuccessMessage && toast.success(response?.data?.message ?? '');
        onDone && onDone(response);
      } else {
        toast.error(response?.data?.message ?? 'Something went wrong');
      }
    } catch (error) {
      onError && onError(error);

      if (isErrorMessage) {
        toast.error(error?.status === 401 ? 'Unauthorize' : error?.data?.message ?? 'Something went wrong');
      }

      if (error?.status === 401) {
        dispatch(setUser(null));
      }
    } finally {
      setLoading && dispatch(setLoading(false));
    }
  };
}

export const iconColor = (svg: any, color?: string) => {
  svg?.querySelectorAll('*').forEach((el) => {
    el?.setAttribute('stroke', color ?? COLORS.primary);
  });
};

export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

export const passwordReg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/
export const nameReg = /^(?=.*[A-Za-z])[A-Za-z0-9 ]+$/
